module.exports = __webpack_public_path__ + "static/media/giniLab.843f54fc.png";